export default __webpack_public_path__ + "ku_light.a4a242c0.svg";